import React from "react";
const DrawnTissuesList = (props) => {
  let { tissues, showDrawnTissue, removeTissue, isTissueImageGenerated } =
    props;
  return (
    <ul>
      <li id="overlay-test-tissue" className="hide-this">
        <p>Liver</p>
        {/* <i className="fas fa-minus" /> */}
        <span className="delete-tissue"> Delete </span>
      </li>
      {Object.keys(tissues).map((key, index) => (
        <li>
          <p onClick={showDrawnTissue.bind(this, key)}>
            {key.replace("_", " ")}
          </p>

          <button
            className="btn_transparent"
            id="complete-image-btn"
            color="#00FFFFFF"
            onClick={removeTissue.bind(this, key)}
            disabled={!isTissueImageGenerated}
          >
            {" "}
            Delete{" "}
          </button>
          {/* <i onClick={removeTissue.bind(this, key)} className="fas fa-minus" /> */}
        </li>
      ))}
    </ul>
  );
};

export default DrawnTissuesList;
